module.exports = __webpack_public_path__ + "img/happy.16e51eb4.svg";